"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SrcSystem = exports.LosgType = exports.DataGroupIdType = exports.ProductSubType = exports.ProductGroupType = exports.requiredToCheckoutType = exports.ItemType = exports.ActionType = exports.LobType = void 0;
/**
 *
 * @export
 * @enum LobType
 */
var LobType;
(function (LobType) {
    LobType["CHANGE"] = "CHANGE";
    LobType["WIRELESS"] = "WIRELESS";
})(LobType = exports.LobType || (exports.LobType = {}));
/**
 *
 * @export
 * @enum ActionType
 */
var ActionType;
(function (ActionType) {
    ActionType["ADD"] = "ADD";
    ActionType["MODIFY"] = "MODIFY";
    ActionType["NO_CHANGE"] = "NO_CHANGE";
    ActionType["REMOVE"] = "REMOVE";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
/**
 *
 * @export
 * @enum ItemType
 */
var ItemType;
(function (ItemType) {
    ItemType["DATAPLAN"] = "DATAPLAN";
    ItemType["DEVICE"] = "DEVICE";
    ItemType["FEATURE"] = "FEATURE";
    ItemType["SHARED_DATA_GROUP"] = "sharedDataGroup";
    ItemType["SHARED_DATA_FEATURE"] = "SHAREDDATAFEATURE";
    ItemType["VOICEPLAN"] = "VOICEPLAN";
    ItemType["ACCESSORY"] = "ACCESSORY";
    ItemType["UPGRADE_SELECTION"] = "UPGRADELINESELECTION";
    ItemType["UPGRADE_OPTION"] = "UPGRADEOPTION";
    ItemType["HARDGOOD"] = "HARDGOOD";
    ItemType["DATA_PLAN"] = "dataplan";
    ItemType["HBOMAX"] = "HBOMAX";
    ItemType["HBOMAX_ADDON"] = "ADDON";
    ItemType["LINENAMEUPDATE"] = "LineNameUpdate";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
/**
 *
 * @export
 * @enum requiredToCheckoutType
 */
var requiredToCheckoutType;
(function (requiredToCheckoutType) {
    requiredToCheckoutType["WLS_DEVICE_CELLPHONE"] = "WLS_DEVICE_CELLPHONE";
})(requiredToCheckoutType = exports.requiredToCheckoutType || (exports.requiredToCheckoutType = {}));
/**
 *
 * @export
 * @enum ProductGroupType
 */
var ProductGroupType;
(function (ProductGroupType) {
    ProductGroupType["WIRELESS"] = "WIRELESS";
    ProductGroupType["DTVNOW"] = "DTVNOW";
    ProductGroupType["HBOMAX"] = "HBOMAX";
})(ProductGroupType = exports.ProductGroupType || (exports.ProductGroupType = {}));
/**
 *
 * @export
 * @enum ProductSubType
 */
var ProductSubType;
(function (ProductSubType) {
    ProductSubType["DATAFEATURE"] = "DATAFEATURE";
    ProductSubType["INSURANCE"] = "INSURANCE";
    ProductSubType["MESSAGING"] = "MESSAGING";
})(ProductSubType = exports.ProductSubType || (exports.ProductSubType = {}));
/**
 *
 * @export
 * @enum DataGroupIdType
 */
var DataGroupIdType;
(function (DataGroupIdType) {
    DataGroupIdType["EXISTING_DG_ID"] = "EXISTING_DGID";
})(DataGroupIdType = exports.DataGroupIdType || (exports.DataGroupIdType = {}));
/**
 *
 * @export
 * @enum LosgType
 */
var LosgType;
(function (LosgType) {
    LosgType["NEW"] = "NEW";
    LosgType["AL"] = "AL";
    LosgType["UP"] = "UP";
    LosgType["ACC"] = "ACC";
    LosgType["NO_CHANGE"] = "NO_CHANGE";
})(LosgType = exports.LosgType || (exports.LosgType = {}));
/**
 *
 * @export
 * @enum SrcSystem
 */
var SrcSystem;
(function (SrcSystem) {
    SrcSystem["IDSE"] = "IDSE";
})(SrcSystem = exports.SrcSystem || (exports.SrcSystem = {}));
//# sourceMappingURL=CartActions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/models/CartActions.js
// module id = 427
// module chunks = 8